import { LoginType, SocialType } from "../../_genApi/gameDeploy";
import Network from "../networkHandler/Network";
import {
  adjectives,
  animals,
  colors,
  countries,
  languages,
  names,
  starWars,
  uniqueNamesGenerator
} from "unique-names-generator";
import { AvatarGenerator } from "random-avatar-generator";
import AbstractAuthModule from "./AbstractAuthModule";
import { login, getMe } from "./auth-api";
import { getDeviceId } from '../device-id';

export default class GuestAuthModule extends AbstractAuthModule {
  loginType = LoginType.GUEST

  constructor() {
    super();
  }

  async start() {
    try {
      await this.loginAsGuest();
    } catch (e) {
      console.error('[GuestAuth] start failed', e);
    }
  }

  private async loginAsGuest() {
    let prevAuthCre = this.readCachedUserInfo();

    if (prevAuthCre?.loginType !== LoginType.GUEST) {
      prevAuthCre = undefined;
    }

    if (prevAuthCre?.zpsToken && prevAuthCre?.name) {
      this.setCurrentUser(prevAuthCre);
      Network.withServerUploadGame().setToken(prevAuthCre.zpsToken);
      Network.withServerAssistant().setToken(prevAuthCre.zpsToken);
      this.onLoggedIn();

      // Background validate cached token; refresh silently if invalid.
      const serverUrl = Network.withServerUploadGame().getServerUrl();
      getMe(serverUrl, prevAuthCre.zpsToken).then((user) => {
        if (!user) {
          console.warn('[GuestAuth] cached token invalid, refreshing');
          this.refreshGuestToken().catch((e) => {
            console.error('[GuestAuth] refresh failed', e);
          });
        }
      });
      return;
    }

    await this.refreshGuestToken();
  }

  private async refreshGuestToken() {
    const deviceId = getDeviceId();
    const serverUrl = Network.withServerUploadGame().getServerUrl();

    const { user, token: zpsToken } = await login(serverUrl, {
      accessToken: deviceId,
      deviceId,
      socialType: SocialType.GUEST,
    });

    const displayName = user.fullName || genRandomName();
    const displayAvatar = user.avatar || genRandomAvatar(displayName);

    this.setCurrentUser({
      name: displayName,
      avatar: displayAvatar,
      tokenType: 'guest',
      loginType: this.loginType,
      zpsToken,
      zpsUserId: user.uid,
      zpsUsername: user.username,
    });

    Network.withServerUploadGame().setToken(zpsToken);
    Network.withServerAssistant().setToken(zpsToken);
    this.onLoggedIn();
  }

  async userReLogin(socialType: SocialType) {
    console.log('GuestAuthModule userReLogin', socialType);
    try {
      await this.loginAsGuest();
    } catch (e) {
      console.error('[GuestAuth] userReLogin failed', e);
    }
  }

  hadLoggedIn() {
    let prevAuthCre = this.readCachedUserInfo();
    return !!prevAuthCre?.zpsToken;
  }

  getLoginToken() {
    return this.getCurrentUser()?.zpsToken;
  }

  async loadToken(socialType: SocialType, authenCode: string) {
    console.error('Guestlogin not supposed to call loadToken, stack = ', new Error());
  }

  getUsername() {
    return this.getCurrentUser()?.name;
  }
}


const banWord = ['handicap']
function genRandomName(maxAttempt = 5) {
  let attempt = 0;
  while (attempt < maxAttempt) {
    let name = uniqueNamesGenerator({
      dictionaries: [adjectives, animals, colors, countries, languages, names, starWars],
      separator: ' ',
      style: "capital",
      length: 3,
    })

    let BANTHISSHIT = banWord.some(some => name.includes(some));
    if (!BANTHISSHIT || attempt >= maxAttempt) {
      return name;
    }
    attempt++;
  }
}

const generator = new AvatarGenerator();
function genRandomAvatar(seed) {
  return generator.generateRandomAvatar(seed);
}
